// extracted by mini-css-extract-plugin
module.exports = {"title":"EditOrderStatusModal_title__jl0hj","subtitle":"EditOrderStatusModal_subtitle__OFh0o"};